import { operatorColors } from '~/utils/operatorColors';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

export const OperatorXorNode = ({ data, notNode = false, onDataChange }) => {
    const handleLeftChange = (newDrop) => onDataChange({ leftDrop: newDrop, rightDrop: data.rightDrop });
    const handleRightChange = (newDrop) => onDataChange({ leftDrop: data.leftDrop, rightDrop: newDrop });
    const layout = data?.layout || 'vertical';
    const isHorizontal = layout === 'horizontal';
    const horizontalDropStyle = isHorizontal ? { minWidth: 80, flex: '0 0 auto', maxWidth: 'none' } : undefined;

    return (
        <div className="node-operator-xor" style={{
            display: 'flex',
            flexDirection: layout === 'vertical' ? 'column' : 'row',
            flexWrap: isHorizontal ? 'nowrap' : 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: '100%'
        }}>
            <CustomInputDrop
                dropData={data.leftDrop || { id: 'left', type: null, data: {} }}
                dropId="left"
                onDropChange={handleLeftChange}
                style={horizontalDropStyle}
            />
            <div style={{
                background: operatorColors['Disjunção exclusiva'] || operatorColors['Igual a'],
                color: 'white',
                borderRadius: '8px',
                padding: '6px 8px',
                fontWeight: 'bold',
                fontSize: '16px',
                width: '52px',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '2px',
                    lineHeight: 1
                }}>
                    <img
                        src="/images/icons/xou.png"
                        alt=""
                        aria-hidden="true"
                        style={{ width: '22px', height: '14px', objectFit: 'contain', display: 'block' }}
                    />
                    <span style={{ fontSize: '10px', fontWeight: 800 }}>XOU</span>
                </div>
            </div>
            <CustomInputDrop
                dropData={data.rightDrop || { id: 'right', type: null, data: {} }}
                dropId="right"
                onDropChange={handleRightChange}
                style={horizontalDropStyle}
            />
            {!notNode && <CustomHandle type="target" position="top" connectionCount={1} />}
            {!notNode && <CustomHandle type="source" position="bottom" connectionCount={1} />}
        </div>
    );
};
